export const INIT_CORALS = 512;
export const MAX_CORALS = 4096;
export const MAX_SPAWN = 100;
export const MAX_FISH = 256;

export const SY = 2027;
export const EY = 2127;
export const FREEZE = -5;
export const EVAP = 100;

export const CT = [
  { n: "Branching", c: [255, 127, 80], s: "branch", rm: 1.1 },
  { n: "Brain", c: [218, 112, 214], s: "round", rm: 0.85 },
  { n: "Plate", c: [255, 182, 108], s: "plate", rm: 1 },
  { n: "Staghorn", c: [144, 238, 144], s: "branch", rm: 1.15 },
  { n: "Pillar", c: [255, 160, 180], s: "pillar", rm: 0.9 },
  { n: "Sea Fan", c: [180, 130, 255], s: "fan", rm: 0.95 },
];

export const FS = [
  { n: "Clownfish", c: [255, 100, 10], sz: 7, dep: 0.95, br: 0.08, isClown: true },
  { n: "Butterflyfish", c: [255, 220, 50], sz: 7, dep: 0.9, br: 0.06 },
  { n: "Parrotfish", c: [50, 200, 150], sz: 9, dep: 0.7, br: 0.08 },
  { n: "Tang", c: [70, 130, 255], sz: 8, dep: 0.65, br: 0.07 },
  { n: "Damselfish", c: [100, 180, 255], sz: 5, dep: 0.85, br: 0.09 },
  { n: "Wrasse", c: [200, 100, 255], sz: 7, dep: 0.6, br: 0.07 },
  { n: "Grouper", c: [160, 120, 80], sz: 11, dep: 0.5, br: 0.04 },
  { n: "Angelfish", c: [255, 180, 60], sz: 8, dep: 0.8, br: 0.06 },
];
